import { default as _91slug_939bc9gqnkIZMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue?macro=true";
import { default as _91slug_93TLC8pLhM8xMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue?macro=true";
import { default as _91name_93JG9ICZqULBMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue?macro=true";
import { default as _91paxid_93iq3JnxRNcMMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue?macro=true";
import { default as _91id_93UB3oWC1OnBMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/payment/[id].vue?macro=true";
import { default as _91id_93FXMOZRVi5fMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/omdome/[id].vue?macro=true";
import { default as _91tab_93VzyJw5BGRtMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue?macro=true";
import { default as _91tab_93ZLFceb5fq8Meta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue?macro=true";
import { default as _91tab_93iBSgQR8EbqMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue?macro=true";
import { default as _91tab_93JDVgpbAwDzMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue?macro=true";
import { default as _91tab_93TseRSCBTEdMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue?macro=true";
import { default as _91slug_93CIfhlOteUMMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/info/[slug].vue?macro=true";
import { default as _91id_93emEUsa9NezMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/fn/[id].vue?macro=true";
import { default as _91tab_93YWxCqr3O88Meta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue?macro=true";
import { default as _91slug_93p8hn9U1h1mMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/competition/[slug].vue?macro=true";
import { default as _91slug_93KdWwq0Blz7Meta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue?macro=true";
import { default as _91ocr_93rjEnl8wrzLMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue?macro=true";
import { default as _91ocr_93IBIJfK1fVGMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue?macro=true";
import { default as _91id_9395pCkM5JU2Meta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue?macro=true";
import { default as _91tripid_93rY0YRGFZ64Meta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue?macro=true";
import { default as _91step_93zl515FIiI5Meta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue?macro=true";
import { default as _91slug_93e7U4131sGvMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue?macro=true";
import { default as _91jwt_93QKoAKRnbFeMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue?macro=true";
import { default as _91tab_93mWX5J6LByrMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue?macro=true";
import { default as indexLA1HoiJ3ZrMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/app/index.vue?macro=true";
import { default as callbacka6cS1xQNEsMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/callback.vue?macro=true";
import { default as blackweekocwYeFus6XMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/blackweek.vue?macro=true";
import { default as _91slug_93YqeYg9jFEbMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/[slug].vue?macro=true";
import { default as indexU5hvwSjRNHMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/index.vue?macro=true";
import { default as bookcallGizjdxm5zLMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookcall.vue?macro=true";
import { default as byebyeieM4rVJqIPEJMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/byebyeie.vue?macro=true";
import { default as index2B8o6KWMufMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/index.vue?macro=true";
import { default as lastminute7GUgzZ5GUlMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue?macro=true";
import { default as _91name_93oIg4fBl4liMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/[name].vue?macro=true";
import { default as indexNAbl8KR5PPMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/index.vue?macro=true";
import { default as cataloguevQ7DHXmHINMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/catalogue.vue?macro=true";
import { default as complaintajR3FrSCvoMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/complaint.vue?macro=true";
import { default as dinbokning_45aktuellfEtlIBGqFlMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/dinbokning-aktuell.vue?macro=true";
import { default as _91slug_93HOylr6MoRdMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/[slug].vue?macro=true";
import { default as indexm63NfMykXiMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/index.vue?macro=true";
import { default as faqfvaMjUnLszMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/faq.vue?macro=true";
import { default as _91id_93Y87DwOsWQAMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/giftcard/[id].vue?macro=true";
import { default as indexhOofgxsogXMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/giftcard/index.vue?macro=true";
import { default as _91name_93L9gzlFn9GCMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/hotels/[name].vue?macro=true";
import { default as indexmYtUDp9IzIMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/hotels/index.vue?macro=true";
import { default as indexhUxUOkpZfNMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/index.vue?macro=true";
import { default as grouptravelCyz95rpv4dMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/grouptravel.vue?macro=true";
import { default as indexfgLYvDyrBpMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/index.vue?macro=true";
import { default as reviewsPXh6sSZfakMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/reviews.vue?macro=true";
import { default as lastminuteGdyy7W4EgnMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/lastminute.vue?macro=true";
import { default as mapNBX6zGFZmFMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/map.vue?macro=true";
import { default as dinbokninglRwePM2yLLMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/mytrip/dinbokning.vue?macro=true";
import { default as newsletterxQTXcBQBT5Meta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/newsletter.vue?macro=true";
import { default as offlinexrXNFW8lGeMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/offline.vue?macro=true";
import { default as failednvmND7boD4Meta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/payment/failed.vue?macro=true";
import { default as indexxVWDgKWuV0Meta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/review/index.vue?macro=true";
import { default as searchSt7RSmYEbYMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/search.vue?macro=true";
import { default as indexpoaWhHAqwQMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/tourleader/index.vue?macro=true";
import { default as verification_45done6HkJV3dQHuMeta } from "/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/verification-done.vue?macro=true";
export default [
  {
    name: "tourleader-id",
    path: "/reseledare/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "titinerary",
    path: "/dagprogram",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "shipinfo",
    path: "/fartyg",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "satisfactionstatus-triptypeid",
    path: "/nojdhet-status/:triptypeid()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "omdome",
    path: "/omdome",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "mytrip",
    path: "/dinresa",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "info-solo",
    path: "/info/solo",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue")
  },
  {
    name: "info-lectures",
    path: "/info/forelasningar",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "info-connections",
    path: "/info/anslutning",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-about",
    path: "/info/om",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "fn",
    path: "/fn",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "destination-slug",
    path: "/destination/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "competition",
    path: "/tavling",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "category",
    path: "/kategori",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "bookingfaq",
    path: "/boknings-faq",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "booking-finish",
    path: "/booking-finish",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking-confirmation",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "bookflight",
    path: "/boka-flyg",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "book-tripid",
    path: "/boka/:tripid()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "auth",
    path: "/medlem",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "app-l",
    path: "/app/l",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "triptype-slug",
    path: "/:triptype()/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "triptype-slug-tab",
    path: "/:triptype()/:slug()/:tab()",
    meta: _91tab_93mWX5J6LByrMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/app/index.vue")
  },
  {
    name: "app-l-jwt",
    path: "/app/l/:jwt()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "auth-slug",
    path: "/medlem/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "auth-callback",
    path: "/medlem/callback",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/callback.vue")
  },
  {
    name: "blackweek",
    path: "/blackweek",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/blackweek.vue")
  },
  {
    name: "blog-slug",
    path: "/blogg/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "/blogg",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/index.vue")
  },
  {
    name: "book-tripid-step",
    path: "/boka/:tripid()/:step()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "bookcall",
    path: "/boka-samtal",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookcall.vue")
  },
  {
    name: "bookflight-tripid",
    path: "/boka-flyg/:tripid()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "booking-confirmation-id",
    path: "/booking-confirmation/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "booking-finish-ocr",
    path: "/booking-finish/:ocr()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "bookingfaq-ocr",
    path: "/boknings-faq/:ocr()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "byebyeie",
    path: "/byebyeie",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/byebyeie.vue")
  },
  {
    name: "calendar",
    path: "/kalender",
    meta: index2B8o6KWMufMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/index.vue")
  },
  {
    name: "calendar-lastminute",
    path: "/kalender/sista-minuten",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue")
  },
  {
    name: "campaign-name",
    path: "/kampanj/:name()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/[name].vue")
  },
  {
    name: "campaign",
    path: "/kampanj",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/index.vue")
  },
  {
    name: "catalogue",
    path: "/katalog",
    meta: cataloguevQ7DHXmHINMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/catalogue.vue")
  },
  {
    name: "category-slug",
    path: "/kategori/:slug()",
    meta: _91slug_93KdWwq0Blz7Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "competition-slug",
    path: "/tavling/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "complaint",
    path: "/reklamation",
    meta: complaintajR3FrSCvoMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/complaint.vue")
  },
  {
    name: "destination-slug-tab",
    path: "/destination/:slug()/:tab()",
    meta: _91tab_93YWxCqr3O88Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "dinbokning-aktuell",
    path: "/dinbokning-aktuell",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/dinbokning-aktuell.vue")
  },
  {
    name: "event-slug",
    path: "/event/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/[slug].vue")
  },
  {
    name: "event",
    path: "/event",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/index.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/faq.vue")
  },
  {
    name: "fn-id",
    path: "/fn/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "giftcard-id",
    path: "/presentkort/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/giftcard/[id].vue")
  },
  {
    name: "giftcard",
    path: "/presentkort",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/giftcard/index.vue")
  },
  {
    name: "hotels-name",
    path: "/hotell/:name()",
    meta: _91name_93L9gzlFn9GCMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/hotels/[name].vue")
  },
  {
    name: "hotels",
    path: "/hotell",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/hotels/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/index.vue")
  },
  {
    name: "info-slug",
    path: "/info/:slug()",
    meta: _91slug_93CIfhlOteUMMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "info-about-tab",
    path: "/info/om/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info-connections-tab",
    path: "/info/anslutning/:tab()",
    meta: _91tab_93JDVgpbAwDzMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-grouptravel",
    path: "/info/gruppresor",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/grouptravel.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/index.vue")
  },
  {
    name: "info-lectures-tab",
    path: "/info/forelasningar/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "info-reviews",
    path: "/info/reviews",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/reviews.vue")
  },
  {
    name: "info-solo-tab",
    path: "/info/solo/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue")
  },
  {
    name: "lastminute",
    path: "/sista-minuten-erbjudanden",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/lastminute.vue")
  },
  {
    name: "map",
    path: "/karta",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/map.vue")
  },
  {
    name: "mytrip-tab",
    path: "/dinresa/:tab()",
    meta: _91tab_93VzyJw5BGRtMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "mytrip-dinbokning",
    path: "/mytrip/dinbokning",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/mytrip/dinbokning.vue")
  },
  {
    name: "newsletter",
    path: "/nyhetsbrev",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/newsletter.vue")
  },
  {
    name: "offline",
    path: "/offline",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/offline.vue")
  },
  {
    name: "omdome-id",
    path: "/omdome/:id()",
    meta: _91id_93FXMOZRVi5fMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "payment-failed",
    path: "/payment/failed",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/payment/failed.vue")
  },
  {
    name: "review",
    path: "/utvardera-resa",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/review/index.vue")
  },
  {
    name: "satisfactionstatus-triptypeid-paxid",
    path: "/nojdhet-status/:triptypeid()/:paxid()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "search",
    path: "/sok",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/search.vue")
  },
  {
    name: "shipinfo-name",
    path: "/fartyg/:name()",
    meta: _91name_93JG9ICZqULBMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "titinerary-slug",
    path: "/dagprogram/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "tourleader-id-slug",
    path: "/reseledare/:id()/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "tourleader",
    path: "/reseledare",
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/tourleader/index.vue")
  },
  {
    name: "verification-done",
    path: "/verification-done",
    meta: verification_45done6HkJV3dQHuMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-30-1446/rtg-monorepo/src/layers/web/pages/verification-done.vue")
  }
]